import React from "react";
import timer from "../../images/webflow/Heart_Sounds.png"

function Timer() {
  return (
    <div class="homepage-marketing-section wf-section">
      <div class="homepage-marketing-container w-container">
        <div class="marketing-columns w-row">
          <div class="w-col w-col-6">
            <div class="marketing-image-div">
              <img
                src={timer}
                loading="lazy"
                alt=""
              />
            </div>
          </div>
          <div class="w-col w-col-6">
            <div class="marketing-text-div">
              <h2 class="heading"> Become an expert diagnostician</h2>
              <div class="subheading-text">
              Listen to the heart murmurs, interpret the CXRs, and read the ECGs. <br></br><br></br>We incorporate media and real presentations into our stations using videos, images & audio to help you recognise the signs.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Timer;
